import axios from "@/plugins/axios";

export default {
    
    list(creditor_id, start_date, end_date, debt_base_id, debt_node_id=null) {
        let params = {
            creditor_id,
            debt_base_id,
            start_date,
            end_date,
            order: "creditor_id",
            limit: 9999,
        };
        if(debt_node_id) params.debt_node_id = debt_node_id

        return axios.httpApi.get("/stimulus-history", {params});
    },
}